import { FunctionComponent, useState } from 'react';
import {
    Card,
    CardContent,
    InputAdornment,
    SvgIcon,
    FilledInput,
    InputLabel,
    FormControl,
} from '@mui/material';
import MagnifyingGlassIcon from '@heroicons/react/24/solid/MagnifyingGlassIcon';

type CouponSearch = {
    onChange: (nextValue: string) => void;
};

export const CouponSearch: FunctionComponent<CouponSearch> = ({ onChange }) => {
    const [textValue, setTextValue] = useState('');

    const handleTextChange = (event) => {
        const { value } = event.target;

        setTextValue(value);
        onChange(value);
    };

    return (
        <Card
            sx={{
                width: '100%',
            }}
        >
            <CardContent>
                <FormControl variant='filled' fullWidth>
                    <InputLabel>Coupons durchsuchen</InputLabel>
                    <FilledInput
                        value={textValue}
                        onChange={handleTextChange}
                        startAdornment={
                            <InputAdornment position='start'>
                                <SvgIcon>
                                    <MagnifyingGlassIcon />
                                </SvgIcon>
                            </InputAdornment>
                        }
                        fullWidth
                    />
                </FormControl>
            </CardContent>
        </Card>
    );
};
